
import Vue from "vue";
import Component from "vue-class-component";
import { Getter, State } from "vuex-class";
import { Prop } from "vue-property-decorator";

@Component
export default class HeaderPartnership3 extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;

  @Prop({ default: [] })
  private industries!: Array<any>;
  @Prop({ default: [] })
  private countries!: Array<any>;
  @Prop({ default: [] })
  private provinces!: Array<any>;
  @Prop({ default: [] })
  private cities!: Array<any>;
  @Prop({ default: false })
  private canReSendOtp!: boolean;
  @Prop({ default: false })
  private isEmptyAgreement!: boolean;
  @Prop({ default: 1 })
  private step!: number;
  @Prop({ default: "" })
  private otpTimer!: string;
  @Prop({ default: false })
  private isReSendOtp!: boolean;
  @Prop({ default: false })
  private imageCropper!: boolean;
  @Prop({ default: null })
  private partnership!: any;
  @Prop({ default: null })
  private partnershipCheck!: any;
  @Prop({ default: null })
  private debounceFind!: any;
  @Prop({ default: null })
  private downloadLatestAgreement!: any;
  @Prop({ default: null })
  private onCountryChange!: any;
  @Prop({ default: null })
  private onProvinceChange!: any;
  @Prop({ default: null })
  private openFile!: any;
  @Prop({ default: null })
  private onAgreementChange!: any;
  @Prop({ default: null })
  private onlyNumber!: any;
  @Prop({ default: null })
  private isEmpty!: any;
  @Prop({ default: null })
  private sendOtp!: any;
  @Prop({ default: null })
  private next!: any;

  @Getter("twoColor")
  private twoColor!: { text: string; bg: string; border: string };

  private get twoBgColor() {
    return this.twoColor.bg;
  }
}
